import { QueryHandler } from '../../_base/actionBus/QueryHandler';
import { GetDocuments } from './GetDocuments';
import { Document } from '../../models/documents/Document';
import { DocumentService } from '../../models/documents/DocumentService';
import { GetPublicDocuments } from './GetPublicDocuments';

export class GetPublicDocumentsHandler implements QueryHandler<GetDocuments, Document[]> {
    constructor(private documentService: DocumentService) {}

    async handle(query: GetPublicDocuments): Promise<Document[]> {
        return await this.documentService.getPublicDocuments(query.associationId, query.parentId);
    }
}
